import { ApiError, NetworkError } from '@opengoal/http';

/**
 * The sentence to show a user for a failed request.
 *
 * `ApiError` and `NetworkError` both already carry copy written for people —
 * the HTTP layer normalizes the backend's envelope and fills in a readable
 * default for bare status codes. This exists so screens stop reaching for
 * `String(error)`, which renders "[object Object]" for anything thrown that is
 * not an Error, and leaks stack-shaped text for the rest.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError || error instanceof NetworkError) return error.message;
  if (error instanceof Error) return error.message;
  return 'Something went wrong. Please try again.';
}
